import { useRouter } from 'next/router';
import WinCommon from '../WinCommon';
import { textLangCommon } from '../textLangCommon';
import './index.scss';
import { textLang } from './textLang';
export default function WinCommonA({ callback, okCallback }: { callback: any; okCallback: any }) {
    const { locale = 'us' } = useRouter();
    const TextA = textLang[locale] || textLang['us'];
    const TextB = textLangCommon[locale] || textLangCommon['us'];
    const btnDataLayer = {
        event: 'uaEvent',
        event_name: 'check_in_success',
        position: `1_Deduct EcoCredits`,
        button_name: TextB.btn1,
        list_name: 'none',
    };
    return (
        <WinCommon
            callback={callback}
            title={TextB.title}
            desc={TextA.sureBeforeDesc1}
            btnText={TextB.btn1}
            okCallback={okCallback}
            btnDataLayer={btnDataLayer}
        />
    );
}
